import CartItemsTable from './cart-items-table';
import EmptyCart from './empty-cart';
import { CartContentProps } from '../types';

const CartContent = ({
  loading,
  className,
  lineItems,
  onUpdateQuantity,
  onRemove,
  isViewOnly,
  browseProductsHref,
  overStockQuoteUrl,
}: CartContentProps) => {
  const cartHasProducts = lineItems?.filter((item) => !item.deleted).length ?? 0;

  return (
    <div className={className}>
      {cartHasProducts ? (
        <CartItemsTable
          items={lineItems}
          isViewOnly={isViewOnly}
          onUpdateQuantity={onUpdateQuantity}
          onRemove={onRemove}
          overStockQuoteUrl={overStockQuoteUrl}
        />
      ) : (
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
          <EmptyCart loading={loading} browseProductsHref={browseProductsHref} />
        </div>
      )}
    </div>
  );
};

export default CartContent;
